import { useCallback, useState } from "react";

// A boolean the browser remembers. For view preferences only -- it lives in
// localStorage, so it is per-browser and never reaches the server.
export function useStickyFlag(key, fallback) {
  const [value, setValue] = useState(() => {
    try {
      const raw = window.localStorage.getItem(key);
      // Compared explicitly rather than coerced: `false` is a real stored
      // value, and `stored || fallback` would flip it back on every reload.
      if (raw === "true") return true;
      if (raw === "false") return false;
      return fallback;
    } catch (_) {
      return fallback;
    }
  });

  const set = useCallback((next) => {
    setValue(next);
    try {
      window.localStorage.setItem(key, next ? "true" : "false");
    } catch (_) {}
  }, [key]);

  return [value, set];
}
